<div *ngFor="let keysLine of keys" class="keys-line">
  <div *ngFor="let key of keysLine" class="key btn-primary" (click)="onKeyClick(key)">{{key}}</div>
</div>
